import { TITLE_ICON_TYPE } from '~/common/componentMapper/QuestionBox/constants';

export const ARIA_LABELS = {
  [TITLE_ICON_TYPE.NEW]: 'New Icon',
  [TITLE_ICON_TYPE.BOLT]: 'Question answered from extraction',
  [TITLE_ICON_TYPE.USER]: 'Question answered by user',
  [TITLE_ICON_TYPE.AUTOMATION]: 'Question answered by Automation',
};
